import React from 'react'

import {
  Header,
  LoadingSpinner,
  getLoadingSpinnerProps,
} from '@LTIDashboard/modules/common'
import { Details } from '@LTIDashboard/modules/GeneralDashboard/Connection/Details'
import { useConnectionValue } from '@LTIDashboard/state'

export function Connection() {
  const { connection, status } = useConnectionValue()
  const ConnectionComponents = {
    loading: {
      Component: LoadingSpinner,
      componentProps: getLoadingSpinnerProps(),
      headerProps: { title: 'No Connection', status: 'neutral' },
    },
    loaded: {
      Component: Details,
      componentProps: { connection: connection },
      headerProps: { title: 'Connection Established', status: 'ok' },
    },
  }

  const { Component, componentProps, headerProps } =
    ConnectionComponents[status]
  return (
    <div className="border rounded card-myed p-3">
      <React.Fragment>
        <Header {...headerProps} />
        <Component {...componentProps} />
      </React.Fragment>
    </div>
  )
}
